<template>
	<div class="mainWrapper direct-purchase">
		<b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
		<h1>Export Warehouse Stock Transfer</h1>
		<div class="form">
			<!-- <div v-if="brands.length > 0">
				<span class="label">BRAND (optional)</span>
				<b-autocomplete
					v-model="brandSuggestions"
					:data="filteredBrands"
					:open-on-focus="true"
					placeholder="Brand"
					field="name"
					@select="option => (selectedBrand = option)"
					class="brandAutocomplete"
				>
					<template slot="empty">No results found</template>
				</b-autocomplete>
			</div> -->

			<div>
				<span class="label">FROM DATE (required)</span
				><b-datepicker :date-formatter="dateFormatter" v-model="fromDate" icon="calendar-today"> </b-datepicker>
			</div>
			<div>
				<span class="label">TO DATE (required)</span
				><b-datepicker :date-formatter="dateFormatter" v-model="toDate" :min-date="minDate" icon="calendar-today"> </b-datepicker>
			</div>
		</div>

		<div class="detail-buttons-wrapper">
			<div></div>
			<div class="align-right">
				<button class="big-button" @click="submit()">EXPORT</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ExportProductTransfer',
	data: function() {
		return {
			isLoading: false,
			brands: [], // List of brands from API
			selectedBrand: null, // Selected brand
			brandSuggestions: '', // List of brands
			transfers: [], // Selected products
			shops: [],
			shopsSuggestions: '',
			selectedShop: null,
			warehouse: null,
			fromDate: null,
			toDate: null,
			minDate: null,
			limit: 10
		}
	},

	computed: {
		filteredShops() {
			return this.shops.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.shopsSuggestions.toLowerCase()) >= 0
				)
			})
		},

		filteredBrands() {
			return this.brands.filter(option => {
				return (
					option.name
						.toString()
						.toLowerCase()
						.indexOf(this.brandSuggestions.toLowerCase()) >= 0
				)
			})
		}
	},

	watch: {
		fromDate: function(data) {
			if (data !== null) {
				this.minDate = data
				this.toDate = data
			} else {
				this.endingDate = null
			}
		}
	},

	mounted: async function() {
		await this.getShops()

		// Get list of brands
		const data = {
			populate: ['suppliers']
		}

		const apiGetWarehouse = await this.$api.getWarehouse({ data })

		this.warehouse = apiGetWarehouse.data._id

		this.supplier = apiGetWarehouse.data.suppliers[0]._id

		// Get brands name which are related to this warehouse
		await Promise.all(
			apiGetWarehouse.data.suppliers[0].brand.map(async brand => {
				const brandData = {
					id: brand
				}

				const apiGetBrand = await this.$api.getBrand({ data: brandData })

				if (apiGetBrand !== undefined) {
					this.brands.push(apiGetBrand.data.list[0])
				}
			})
		)
	},

	methods: {
		submit: async function() {
			if (!this.fromDate || !this.toDate) {
				this.$swal.fire('Error!', 'From Date and To Date are required fields!', 'error')
				return
			}

			this.isLoading = true
			this.transfers = []
			var totalLoop = 0

			const apiData = await this.getStockTransfer()

			if (apiData && apiData.total < 1) {
				this.$swal.fire('No Data!', 'No date for selected date!', 'info')
				this.isLoading = false
				return
			}

			// Add transfer into state
			apiData.list.map(item => {
				this.transfers.push(item)
			})

			// Prepare CSV
			if (this.transfers.length > 0) {
				let export_csv = ''

				export_csv += 'TRANSFER CODE,TRANSFER DATE,AUTHOR,BD CODE,BARCODE,PRODUCT NAME,FROM,TO,TRANSFERRED QUANTITY,REMARK\r\n'

				// Loop data
				this.transfers.map(transfer => {
					// Map all the transfer products
					transfer.product.map(product => {
						const productDetail = product.product

						const toAdd = [
							transfer.code, // CODE
							transfer.transfer_date ? this.$moment(transfer.transfer_date).format('DD/MM/YY') : '', // Transfer Date
							transfer.author.name, // SHOP
							productDetail.bd_code, // BD CODE
							productDetail.barcode, // BARCODE
							'"' + productDetail.name + '"', // PRODUCT NAME
							product.from, // FROM
							product.to, // TO
							product.stock, // TRANSFERRED QUANTITY
							product.description ? '"' + product.description + '"' : '' // REMARK
						]

						let row = toAdd.join(',')

						export_csv += row + '\r\n'
					})

					export_csv += '\r\n'
				})

				this.isLoading = false

				const fileNameDate = this.$moment().format('DD/MM/YY')
				let filename_date = this.$moment().format('DDMMYYhhmmss')

				var csvData = new Blob([export_csv], { type: 'text/csv' }) //new way
				var csvUrl = URL.createObjectURL(csvData)

				var link = document.createElement('a')
				link.setAttribute('href', csvUrl)
				link.setAttribute('download', fileNameDate + '_Warehouse_Stock_Transfer_' + filename_date + '.csv')
				document.body.appendChild(link) // Required for FF

				link.click()
				link.remove()
			}
		},

		getStockTransfer: async function() {
			// Make sure to set in specific time
			const createdAt = {}

			createdAt['$gte'] = this.$moment(this.fromDate)
				.set({ hour: 0 })
				.format('x')

			createdAt['$lte'] = this.$moment(this.toDate)
				.set({ hour: 24 })
				.format('x')

			var data = {
				limit: 1000,
				populate: ['author', 'product.product'],
				time: {
					createdAt
				}
			}

			// If brand is selected, add brand
			if (this.selectedBrand) {
				data.brand = this.selectedBrand._id
			}

			const apiGetTransfer = await this.$api.getStockTransfer({ data })

			if (apiGetTransfer) {
				return apiGetTransfer.data
			}
		},

		removeItem: function(index) {
			this.products.splice(index, 1)
		},

		dateFormatter(dt) {
			return dt.toLocaleDateString('en-GB')
		},

		// Get list of shops
		getShops: async function() {
			const apiGetShops = await this.$api.getShops()

			this.shops = apiGetShops.data.list
		}
	}
}
</script>

<style scoped>
@import '../styles/AddProductTransfer.css';
</style>
